import { Link } from "react-router-dom";
import { motion } from "motion/react";

const reportTypes = [
  {
    icon: "ri-file-search-line",
    title: "물건분석 리포트",
    description:
      "경매 물건의 권리관계, 시세, 수익성을 전문가가 분석해드립니다. 초보자도 안심하고 투자할 수 있도록 상세한 가이드를 제공합니다.",
    price: "49,000원",
    href: "/reports?type=item",
  },
  {
    icon: "ri-map-pin-line",
    title: "지역분석 리포트",
    description:
      "서울, 경기, 인천 등 주요 투자 지역별 시세 동향과 전망을 데이터 기반으로 분석한 리포트입니다.",
    price: "79,000원",
    href: "/reports?type=region",
  },
  {
    icon: "ri-checkbox-line",
    title: "투자 체크리스트",
    description:
      "경매 투자 전 반드시 확인해야 할 항목을 체계적으로 정리한 체크리스트. 놓치기 쉬운 위험 요소까지 꼼꼼하게 체크하세요.",
    price: "29,000원",
    href: "/reports?type=checklist",
  },
];

const sectionVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] as const },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] as const },
  },
};

export default function ReportSection() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={sectionVariants}
      className="w-full py-16 md:py-20 px-4 md:px-6 bg-[#FAFAF8]"
    >
      <div className="max-w-[1280px] mx-auto">
        {/* Section Header */}
        <motion.div variants={fadeUpVariants} className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-[#C4956A]/10 text-[#C4956A] rounded-full mb-3">
            전문 분석 서비스
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-3">
            물건분석 리포트
          </h2>
          <p className="text-sm text-[#8C8780] max-w-[500px] mx-auto">
            혼자 하기 어려운 권리분석과 수익성 검토,
            <br />
            전문가의 꼼꼼한 분석 리포트로 안전하게 투자하세요
          </p>
        </motion.div>

        {/* Report Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reportTypes.map((report, idx) => (
            <motion.div
              key={idx}
              variants={cardVariants}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 15 }}
            >
              <Link
                to={report.href}
                className="group bg-white rounded-xl border border-[#E8E5E0] p-6 md:p-8 hover:border-[#C4956A]/30 transition-all text-left block"
              >
                <div className="w-12 h-12 rounded-xl bg-[#C4956A]/10 flex items-center justify-center mb-5 group-hover:bg-[#C4956A]/20 transition-colors">
                  <i className={`${report.icon} text-xl text-[#C4956A]`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#1C1917] mb-3">
                  {report.title}
                </h3>
                <p className="text-sm text-[#8C8780] leading-relaxed mb-5">
                  {report.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-[#F0EDE8]">
                  <span className="text-lg font-bold text-[#C4956A]">
                    {report.price}
                  </span>
                  <span className="flex items-center gap-1 text-sm font-medium text-[#5C5650] group-hover:text-[#C4956A] transition-colors">
                    자세히 보기
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}